import React, { useEffect } from 'react';

import { Form, Input, Checkbox } from 'antd';
import FormLabel from 'components/FormLabel';
import PhoneInput, { validPhoneNumber } from 'components/PhoneInput';
import messages from './messages';

const UpsertUserForm = ({ form, onSubmit, user, availableRoles = [] }) => {
  useEffect(() => form.resetFields(), [user]);

  const initialValues = user && {
    firstname: user.firstname,
    lastname: user.lastname,
    phone: user.phone,
    roleIds: user.roles?.map((role) => role.id),
  };

  const toOption = (role) => ({ label: role.name, value: role.id });
  const internalRoleOpts = availableRoles.map(toOption);

  return (
    <Form
      layout="vertical"
      form={form}
      onFinish={onSubmit}
      initialValues={initialValues}
    >
      <Form.Item
        label={<FormLabel label={messages.email} />}
      >
        <Input disabled value={user.email} />
      </Form.Item>
      <Form.Item
        name="firstname"
        label={<FormLabel label={messages.firstname} />}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="lastname"
        label={<FormLabel label={messages.lastname} />}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="phone"
        label={<FormLabel label={messages.phone} />}
        rules={[validPhoneNumber]}
      >
        <PhoneInput />
      </Form.Item>
      <Form.Item
        name="roleIds"
        label={<FormLabel label={messages.internalRoles} />}
      >
        <Checkbox.Group options={internalRoleOpts} />
      </Form.Item>
    </Form>
  );
};

export default UpsertUserForm;
